let colors = {
	art: '#ED5224',
	business: '#2C2D2F',
	career: '#B67E5C',
	family: '#25468D',
	sport: '#C21734',
}

let shares = {
	art: '',
	business:
		'Оставьте свой мейл и получайте программы Михаила Перегудова, которые помогут стать более успешным в бизнесе.',
	career: 'Оставьте свой мейл и получайте программы по развитию карьеры от Алены Владимирской.',
	family: 'Оставьте свой мейл и получайте программы от Ларисы Сурковой, которые помогут укрепить отношения в семье.',
	sport: 'Оставьте свой мейл и получайте программы от Максима Журило, которые помогут прокачать свою спортивную форму.',
	main: 'Оставьте свой мейл и получайте программы от Максима Журило, которые помогут прокачать свою спортивную форму.',
}

let url = 'http://kia-sportage.lenta.ru'

export { url, colors, shares }
